'use strict';
/* Controllers for the messaging feature */
import { MessageActions } from "../../../../../../ngapp/src/app/message-list/state/message.actions";
/**
 * Main screen controller for the messaging screen
 */
angular.module('autoremind.messaging', [])
    .controller('autoremind.messaging.ScreenController', 
// Setup dependencies
['$scope', '$http', '$enhancedHttp', '$q', '$filter', 'logger', 'userProfile', 'angularMomentConfig', 'dialogs', 'storeDowngraded',
    function ($scope, $http, $enhancedHttp, $q, $filter, logger, userProfile, angularMomentConfig, dialogs, storeDowngraded) {
        logger.info('In autoremind.messaging.ScreenController');
        userProfile.initalizeViewModel();
        if (userProfile.viewModel.views.messaging == undefined) {
            // This is the first time opening the logs view, so initialize
            userProfile.viewModel.views.messaging = {};
            userProfile.viewModel.views.messaging.destinatorSelected = '';
            userProfile.viewModel.views.messaging.showCustomer = false;
            userProfile.viewModel.views.messaging.mediaSearch = [
                { label: "All", value: "" },
                { label: "Email", value: "email" },
                { label: "SMS", value: "sms" },
                { label: "Voice", value: "voice" }
            ];
            userProfile.viewModel.views.messaging.mediaSelected = '';
            userProfile.viewModel.views.messaging.applicationSearch = [
                { label: "All", value: "" },
                { label: "Communication", value: "communication" },
                { label: "Reminder (autoremind)", value: "autoremind" }
            ];
            userProfile.viewModel.views.messaging.applicationSelected = '';
            userProfile.viewModel.views.messaging.loadingIndicator = { 'state': false, 'refCount': 0 };
            userProfile.viewModel.views.messaging.loadingMessageData = { 'state': false, 'refCount': 0 };
            userProfile.viewModel.views.messaging.customerQuery = '';
            userProfile.viewModel.views.messaging.loadUsingFilters = true;
        }
        // Map shared model to scope for local reference
        $scope.viewModel = userProfile.viewModel.views.messaging;
        if ($scope.viewModel.summaryFromDate == undefined) {
            $scope.viewModel.summaryFromDate = new Date(new Date().setMonth(new Date().getMonth() - 1));
            $scope.viewModel.summaryFromDate.setHours(0);
            $scope.viewModel.summaryFromDate.setMinutes(0);
            $scope.viewModel.summaryFromDate.setSeconds(0);
            $scope.viewModel.summaryToDate = new Date();
            $scope.viewModel.summaryToDate.setHours(0);
            $scope.viewModel.summaryToDate.setMinutes(0);
            $scope.viewModel.summaryToDate.setSeconds(0);
        }
        if ($scope.viewModel.messagesFromDate == undefined) {
            $scope.viewModel.messagesFromDate = new Date(new Date().setDate(new Date().getDate() - 7));
            $scope.viewModel.messagesFromDate.setHours(0);
            $scope.viewModel.messagesFromDate.setMinutes(0);
            $scope.viewModel.messagesFromDate.setSeconds(0);
            $scope.viewModel.messagesToDate = new Date();
            $scope.viewModel.messagesToDate.setHours(23);
            $scope.viewModel.messagesToDate.setMinutes(59);
            $scope.viewModel.messagesToDate.setSeconds(59);
        }
        if ($scope.viewModel.summarySort == undefined) {
            $scope.viewModel.summarySort = { column: "autoremindAccountName", descending: false };
        }
        if ($scope.viewModel.messagesSort == undefined) {
            $scope.viewModel.messagesSort = { column: "createdInt", descending: true };
        }
        $scope.selectCustomer = function (customer) {
            $scope.viewModel.customerSelected = customer;
            $scope.viewModel.customerDropdownOpen = false;
        };
        $scope.fetchSummaryForCustomers = function () {
            logger.debug('autoremind.messaging.ScreenController.fetchSummaryForCustomers() calling server');
            $scope.viewModel.customerSearch = []; // Clear list in UI
            $scope.viewModel.count = { "smsParts": 0, "email": 0, "sms": 0, "voice": 0, "sum": 0, "customer": 0 };
            // Summary dates are in user's browser's timezone, but printing year, month and date is what we need
            // Then the backend will use this for UTC time
            var fromDate = $scope.viewModel.summaryFromDate.toString('yyyy-MM-dd');
            var toDate = $scope.viewModel.summaryToDate.toString('yyyy-MM-dd');
            var servletUrl = '/servlets/gateway/log/summary/?from=' + fromDate + '&to=' + toDate + '';
            $scope.viewModel.loadingIndicator.state = true;
            $enhancedHttp({ method: 'GET', url: servletUrl })
                .then(function (data, status) {
                logger.debug('autoremind.messaging.ScreenController.fetchSummaryForCustomers() got data from server');
                $scope.viewModel.defaultCustomer = data.defaultCustomer;
                var selectedCustomerName = data.defaultCustomer;
                if ($scope.viewModel.customerSelected !== undefined) {
                    // If a customer was previously selected then use this as default for new data set from server
                    selectedCustomerName = $scope.viewModel.customerSelected.autoremindAccountName;
                }
                for (var i = 0; i < data.customers.length; i++) {
                    data.customers[i].sum = 0;
                    data.customers[i].sumWithParts = 0;
                    if (data.customers[i].email) {
                        data.customers[i].sum += data.customers[i].email;
                        data.customers[i].sumWithParts += data.customers[i].email;
                        $scope.viewModel.count.email += data.customers[i].email;
                    }
                    if (data.customers[i].voice) {
                        data.customers[i].sum += data.customers[i].voice;
                        data.customers[i].sumWithParts += data.customers[i].voice;
                        $scope.viewModel.count.voice += data.customers[i].voice;
                    }
                    if (data.customers[i].sms) {
                        data.customers[i].sumWithParts = data.customers[i].sum + data.customers[i].smsParts;
                        data.customers[i].sum += data.customers[i].sms;
                        $scope.viewModel.count.sms += data.customers[i].sms;
                        $scope.viewModel.count.smsParts += data.customers[i].smsParts;
                    }
                    $scope.viewModel.count.customer++;
                    if (data.customers[i].autoremindAccountName === selectedCustomerName) {
                        // Select object in new data set
                        $scope.viewModel.customerSelected = data.customers[i];
                    }
                }
                $scope.viewModel.count.sum = $scope.viewModel.count.email + $scope.viewModel.count.sms + $scope.viewModel.count.voice;
                $scope.viewModel.count.sumWithParts = $scope.viewModel.count.email + $scope.viewModel.count.smsParts +
                    $scope.viewModel.count.voice;
                $scope.viewModel.customerSearch = data.customers;
                /*
                if ($scope.viewModel.customerSelected === undefined || $scope.viewModel.customerSelected === "") {
                    $scope.viewModel.customerSelected = data.defaultCustomer;
                }
                */
                if (data.customers.length > 1) {
                    $scope.viewModel.showCustomer = true;
                }
                else {
                    $scope.viewModel.showCustomer = false;
                }
                $scope.viewModel.summaryForCustomersFromDate = $filter('date')(data.summaryFromDateInt, 'MM/dd/yyyy hh:mm a');
                $scope.viewModel.summaryForCustomersToDate = $filter('date')(data.summaryToDateInt, 'MM/dd/yyyy hh:mm a');
                $scope.viewModel.loadingIndicator.state = false;
                /* Disabled auto loading to avoid locking up the UI if the default 7 days logs takes long to fetch
                if ($scope.viewModel.messageData == undefined) {
                    $scope.fetchMessageData();
                };
                */
            }, function (data, status) {
                $scope.status = status;
                dialogs.error('Error', 'There was a problem getting data from the server. Please try again.');
            });
        };
        if ($scope.viewModel.customerSearch === undefined) {
            //$scope.viewModel.customerSelected = "";
            $scope.fetchSummaryForCustomers();
        }
        // TODO: Move to gatewayService
        $scope.getGatewayMessages = function (from, to, customer, destinator, loadingIndicator, disableErrorDialog) {
            var url = '/servlets/gateway/log/messages/?from=' + from + '&to=' + to + '&customer=' + customer;
            if (destinator !== '') {
                url += '&destinator=' + destinator;
            }
            return $enhancedHttp({
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                url: url,
                errorMessage: 'Failed getting messages from server',
                disableErrorDialog: disableErrorDialog,
                returnHttpResponseOnFail: true,
                handleStatus: 502 // Apache proxy error (probably timeout)
            }, loadingIndicator)
                .then(function (data) {
                return data;
            }, function (response) {
                if (response.status === 502) {
                    dialogs.error('Server Error', 'Failed getting messages from server due to proxy timeout. Try shorter search period.');
                }
                return $q.reject(response.data);
            });
        };
        $scope.fetchMessageData = function () {
            //    	logger.debug('autoremind.messaging.ScreenController.fetchMessageData() calling server (customer=' + $scope.viewModel.customerSelected.autoremindAccountName + ')');
            // Empty list for UI to be empty until new data loaded
            $scope.viewModel.messageData = [];
            var from = $scope.viewModel.messagesFromDate.getTime();
            var to = $scope.viewModel.messagesToDate.getTime();
            var customer = $scope.viewModel.customerSelected === undefined ? '' : encodeURIComponent($scope.viewModel.customerSelected.autoremindAccountName);
            var destinator = '';
            if ($scope.viewModel.loadUsingFilters) {
                destinator = $scope.viewModel.destinatorSelected;
            }
            $scope.getGatewayMessages(from, to, customer, destinator, $scope.viewModel.loadingMessageData)
                .then(function (data) {
                logger.debug('autoremind.messaging.ScreenController.fetchMessageData() got data from server');
                for (var i = 0; i < data.messageList.length; i++) {
                    data.messageList[i].created = $filter('date')(data.messageList[i].createdInt, 'MM/dd/yyyy hh:mm a');
                    data.messageList[i].showEventLog = false;
                    data.messageList[i].showMessageContent = false;
                }
                $scope.viewModel.messageData = data.messageList;
            });
        };
        $scope.fetchMessageDataEventLog = function (messageDataId) {
            logger.debug('autoremind.messaging.ScreenController.fetchMessageDataDataEventLog(' + messageDataId + ') calling server (messageDataId=' + messageDataId + ')');
            var servletUrl = 'servlets/gateway/log/eventlog/' + messageDataId + '/';
            $enhancedHttp({ method: 'GET', url: servletUrl })
                .then(function (data, status) {
                logger.debug('autoremind.messaging.ScreenController.fetchMessageDataDataEventLog() got data from server');
                for (var i = 0; i < data.eventLogs.length; i++) {
                    for (var j = 0; j < data.eventLogs[i].eventLog.length; j++) {
                        data.eventLogs[i].eventLog[j].created = $filter('date')(data.eventLogs[i].eventLog[j].createdInt, 'MM/dd/yyyy hh:mm a');
                    }
                    for (var j = 0; j < $scope.viewModel.messageData.length; j++) {
                        if ($scope.viewModel.messageData[j].messageDataId == data.eventLogs[i].messageDataId) {
                            // NOTE: coercion is intended here
                            $scope.viewModel.messageData[j].eventLog = data.eventLogs[i].eventLog;
                            $scope.viewModel.messageData[j].showEventLog = true;
                            logger.debug('autoremind.messaging.ScreenController.fetchMessageDataDataEventLog() update messageDataId: ' + data.eventLogs[i].messageDataId);
                        }
                    }
                }
            }, function (data, status) {
                $scope.status = status;
                dialogs.error('Error', 'There was a problem getting data from the server. Please try again.');
            });
        };
        $scope.fetchMessageDataContent = function (messageDataId) {
            logger.debug('autoremind.messaging.ScreenController.fetchMessageDataDataContent(' + messageDataId + ') calling server (messageDataId=' + messageDataId + ')');
            var servletUrl = 'servlets/gateway/log/messagedata/' + messageDataId + '/';
            $enhancedHttp({ method: 'GET', url: servletUrl })
                .then(function (data, status) {
                logger.debug('autoremind.messaging.ScreenController.fetchMessageDataDataContent() got data from server');
                for (var i = 0; i < data.messageData.length; i++) {
                    for (var j = 0; j < $scope.viewModel.messageData.length; j++) {
                        if ($scope.viewModel.messageData[j].messageDataId == data.messageData[i].messageDataId) {
                            // NOTE: coercion is intended here
                            //$scope.viewModel.messageData[j].message = data.messageData[i].message;
                            for (var key in data.messageData[i]) {
                                if (key !== "messageDataId") {
                                    $scope.viewModel.messageData[j][key] = data.messageData[i][key];
                                    logger.debug('autoremind.messaging.ScreenController.fetchMessageDataContent() update messageDataId: ' + data.messageData[i].messageDataId + " " + key);
                                }
                                $scope.viewModel.messageData[j].showMessageContent = true;
                            }
                            logger.debug('autoremind.messaging.ScreenController.fetchMessageDataContent() update messageDataId: ' + data.messageData[i].messageDataId);
                        }
                    }
                }
            }, function (data, status) {
                $scope.status = status;
                dialogs.error('Error', 'There was a problem getting data from the server. Please try again.');
            });
        };
        $scope.preview = function (messageUuid, mediaType, messageType) {
            storeDowngraded.dispatch(MessageActions.openMessagePreviewDialogJS({
                messageUuid: messageUuid,
                mediaType: mediaType,
                isTrackingcode: false,
                messageType: messageType
            }));
        };
    }]);
angular.module('autoremind.messaging')
    .directive('previewIframe', function () {
    return {
        restrict: 'A',
        scope: {
            //callback: '&ngOnload',
            content: '=previewIframe'
        },
        link: function (scope, element, attrs) {
            console.log('previewIframe', scope.content, 'jhg');
            element.contents().find('html').html(scope.content);
            scope.print = function () {
                console.log('modal print from previewIframe directive');
                element.print();
            };
        }
    };
});
angular.module('autoremind.messaging')
    .controller('autoremind.messaging.PreviewDialogController', 
// Setup dependencies
['$scope', '$log', '$uibModalInstance', 'data',
    function ($scope, $log, $uibModalInstance, data) {
        $scope.dialog = $uibModalInstance;
        var x2js = new X2JS();
        var jsonObj = x2js.xml_str2json(data.messageContent);
        // var jsonObj = x2js.xml2js( data.messageContent );
        $scope.contentData = jsonObj.message.html;
        $scope.print = function () {
            console.log('modal print from PreviewDialogController  angularJS');
            //var myWindow = window.frames["printableFrame"];
            //myWindow.contentWindow.print();
            var myWindow = document.getElementById('printableFrame');
            var frame = (myWindow.contentWindow || myWindow.contentDocument);
            frame.focus();
            frame.print();
        };
        //$scope.subject = 'Communication Feature: ' + $scope.viewModel.communicationsCategory.communicationsCategoryName;
        //$scope.body = 'Dear AutoRemind Sales,\n\nI am interested in purchasing the Communication feature...';
    }]);
angular.module('autoremind.messaging')
    .controller('autoremind.messaging.LogController', 
// Setup dependencies
['$scope', '$http', '$filter', 'logger', 'userProfile',
    function ($scope, $http, $filter, logger, userProfile) {
        $scope.viewModel = userProfile.viewModel.views.messaging;
        $scope.updateMessageData = function () {
            $scope.viewModel.customerDropdownOpen = false;
            $scope.fetchMessageData();
        };
        $scope.messageDataFilter = function (messageData) {
            //        return true;
            if ($scope.viewModel.mediaSelected !== "") {
                if ($scope.viewModel.mediaSelected !== messageData.media)
                    return false;
            }
            if ($scope.viewModel.applicationSelected !== "") {
                if ($scope.viewModel.applicationSelected !== messageData.application)
                    return false;
            }
            if ($scope.viewModel.customerSelected !== undefined && $scope.viewModel.customerSelected !== "") {
                // NOTE: Inbound messages do not have account (yet) so don't filter by account for inbound
                if ($scope.viewModel.customerSelected.autoremindAccountName !== messageData.autoremindAccountName && messageData.state !== 'inbound' && messageData.autoremindAccountName !== null)
                    return false;
            }
            if ($scope.viewModel.destinatorSelected !== "") {
                var destinator = $scope.viewModel.destinatorSelected;
                var phoneNumberPattern = /^([0-9\(\)\s\-.\,#\+]+)/g;
                if ($scope.viewModel.destinatorSelected.match(phoneNumberPattern)) {
                    destinator = destinator.replace(/[^0-9]/g, ""); //()-., #+
                }
                //  search by destinator case insensitive
                if ((messageData.destinator).toLowerCase().indexOf(destinator.toLowerCase()) === -1)
                    return false;
            }
            return true;
        };
        $scope.selectMessageData = function (messageData, index) {
            if (messageData.showEventLog) {
                messageData.showEventLog = false;
            }
            else if (!messageData.eventLog === undefined && messageData.eventLog.length > 0) {
                messageData.showEventLog = true;
            }
            else {
                messageData.showEventLog = true;
                $scope.fetchMessageDataEventLog(messageData.messageDataId);
            }
        };
        $scope.selectMessageContent = function (messageData, index) {
            console.log('messageData', messageData);
            if (messageData.showMessageContent) {
                messageData.showMessageContent = false;
            }
            else if (!(messageData.message === undefined)) {
                messageData.showMessageContent = true;
            }
            else {
                messageData.showMessageContent = true;
                $scope.fetchMessageDataContent(messageData.messageDataId);
            }
        };
        $scope.changeSorting = function (column) {
            if ($scope.viewModel.messagesSort.column === column) {
                $scope.viewModel.messagesSort.descending = !$scope.viewModel.messagesSort.descending;
            }
            else {
                $scope.viewModel.messagesSort.column = column;
                $scope.viewModel.messagesSort.descending = false;
            }
        };
        $scope.copyToClipboard = function (string) {
            navigator.clipboard.writeText(string);
        };
    }]);
angular.module('autoremind.messaging')
    .controller('autoremind.messaging.SummaryController', 
// Setup dependencies
['$scope', '$http', '$filter', 'logger', 'userProfile',
    function ($scope, $http, $filter, logger, userProfile) {
        $scope.viewModel = userProfile.viewModel.views.messaging;
        $scope.fetchSummary = function () {
            $scope.fetchSummaryForCustomers();
        };
        $scope.changeSorting = function (column) {
            if ($scope.viewModel.summarySort.column === column) {
                $scope.viewModel.summarySort.descending = !$scope.viewModel.summarySort.descending;
            }
            else {
                $scope.viewModel.summarySort.column = column;
                $scope.viewModel.summarySort.descending = false;
            }
        };
    }]);
//# sourceMappingURL=messaging.controllers.js.map